module.exports = __webpack_public_path__ + "static/circle_tag_restaurants-e9af5c6b66374afdffbc2fa7bb864951.png";